import { CustoDropDownItemProps } from '../../../../../components/types';
import { AvailableBrokersAndEstatesState } from '../../../../../store/types/temp-types';
import { UserState } from '../../../../../types/UserState';

export const resolveClaimEstateId = (
  user?: UserState | null,
  availableBrokersAndEstates?: AvailableBrokersAndEstatesState | null,
  estates?: CustoDropDownItemProps[] | null
): string => {
  const fromActiveEstate =
    availableBrokersAndEstates?.activeEstateId || user?.activeEstateId;
  if (fromActiveEstate) {
    return String(fromActiveEstate);
  }

  if (user?.estate?.id) {
    return String(user.estate.id);
  }

  if (estates?.length === 1) {
    const value = estates[0]?.value;
    const id = typeof value === 'object' && value?.id ? value.id : value;
    return id ? String(id) : '';
  }

  return '';
};
